import axios from '../../../utils/request';

function EMAILTEMPLATE(params) {
    return axios.get("/member/AEmailTemplate/index", {
        params: {
            ...params
        }
    } )
}

function CHANG_STATUS (params) {
    return  axios.post("/member/AEmailTemplate/statusEdit",{status:params} )
}

function LIST_ORDER(params) {
    return  axios.post("/member/AEmailTemplate/listOrder",{list_orders:params} )
}

function SUBMIT_ADD(params) {
    return  axios.post("/member/AEmailTemplate/addPost",{...params} )
}

function SUBMIT_EDIT(params) {
    return  axios.post("/member/AEmailTemplate/editPost",{...params} )
}

function DELE(params) {
    return  axios.get("/member/AEmailTemplate/delete",{
        params: {
            ids:params
        }
    } )
}

function EDIT_DATA(params) {
    return  axios.post("/member/AEmailTemplate/edit",{...params} )
}

export default {
    EMAILTEMPLATE,
    CHANG_STATUS,
    LIST_ORDER,
    DELE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
};